// extracted by mini-css-extract-plugin
module.exports = {"content":"blog_content__7_6zF"};